import axios from 'axios'
import {FurnitureModel, ResponseCRUD, ResponseObjectPaginated, ResponseObjectURL} from '../model'
import {TableResumen} from '../../central/model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getFurniture(dto: FurnitureModel, page: number) {
  return axios.post<ResponseObjectPaginated<FurnitureModel[]>>(
    `${BASEURL}/furniture/getAll/${page}`,
    dto,
  )
}
export function getFurnitureById(dto: string | undefined) {
  return axios.get<ResponseObjectPaginated<FurnitureModel[]>>(
    `${BASEURL}/furniture/getInformationById?pointId=${dto}`,
  )
}

export function createFurniture(dto: FurnitureModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/furniture/createFurniture`, dto)
}

export function deleteFurniture(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/furniture/deleteFurniture?id=${dto}`)
}

export function updateFurniture(dto: FurnitureModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/furniture/updateFurniture`, dto)
}
export function getFurnitureByPoint(page: number, id: any) {
  return axios.get<ResponseObjectPaginated<FurnitureModel[]>>(
    `${BASEURL}/profile/getInformationById?vistaPermisoId=${id}&pageNumber=${page}`,
  )
}

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplateFurniture() {
  return axios.post<ResponseObjectURL>(`${BASEURL}/furniture/downloadTemplateBulkLoad`)
}

export function uploadMasiveFurniture(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/furniture/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE
